export default __webpack_public_path__ + "static/media/GR1600-II-both.c90fb76d.jpg";